import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import CommonDialog from "../CommonDialog/CommonDialog";
import { updateCell, getCellById } from "../../services/cellService";
import { toast } from 'react-toastify';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

const EditCell = ({ cellPoupOpen, handleClose, selectedCell, getCellData, existingCells }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (cellPoupOpen && selectedCell) {
            setName(selectedCell.name || '');
            setError('');
        }
    }, [cellPoupOpen, selectedCell]);

    const handleChange = (e) => {
        const input = e.target.value;
        setName(input);

        const trimmedInput = input.trim().toLowerCase();

        if (!trimmedInput) {
            setError('Cell name is required.');
            return;
        }

        const isDuplicate = existingCells.some(cell =>
            cell.name.trim().toLowerCase() === trimmedInput &&
            cell.cell_id !== selectedCell.cell_id
        );

        if (isDuplicate) {
            setError('Cell name already exists for this library.');
        } else {
            setError('');
        }
    };

    const handleUpdate = async () => {
        if (!name.trim()) {
            setError('Cell name is required.');
            return;
        }

            const response = await getCellById(selectedCell.cell_id);
            if(!response.success) return;            
            var data = response.body;
            const resp = await updateCell({
                name: name.trim(),
                library_id: data.library_id,
                cell_id: selectedCell.cell_id
            });
            if(!resp.success) return;
            toast.success('Cell updated successfully.');
            getCellData();
            handleClose();
    };

    return (
        <CommonDialog open={cellPoupOpen} onClose={handleClose} title="Edit Cell">
            <TextField
                fullWidth
                id="title"
                variant="outlined"
                margin="normal"
                label="Cell Name"
                value={name}
                onChange={handleChange}
                error={!!error}
                helperText={error}
                inputProps={{ maxLength: 75 }}
            />
            <>
                <Button variant="outlined"  onClick={handleClose} startIcon={<CancelIcon/>}>Cancel</Button>
                <Button
                    variant="contained"
                    className="customButtonStyle"
                    onClick={handleUpdate}
                    disabled={!!error || !name.trim()}
                    startIcon={<SaveIcon />}
                >
                    Save
                </Button>
            </>
        </CommonDialog>
    );
};

export default EditCell;
